import type { ProductImageInputRoot } from '@repo/sdk'

import { extractImageMetadata } from '../../shared/utils/extractImageMetadata'

export async function buildImagesPayload(urls: string[]): Promise<ProductImageInputRoot[]> {
  return Promise.all(
    urls.map(async (url, index) => {
      const meta = await extractImageMetadata(url)
      return {
        url,
        width: meta.width,
        height: meta.height,
        size: 1,
        mimeType: meta.mimeType,
        order: index,
      }
    }),
  )
}
